/* eslint-disable react/jsx-pascal-case */
import React, { useCallback, useEffect, useState } from 'react';
import css from './styles.module.scss';
import { useSelector } from 'react-redux';
import { selectNewSong, selectNewSongStep, selectIsSongEditing } from '~/features/dashboard/store/selectors';
import { useRouteMatch } from 'react-router-dom';
import { newSongFormGoToStep, newSongFormPrevStep, resetNewSongForm } from '~/features/dashboard/store/actions';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import { Box, Step, StepLabel, Stepper } from '@material-ui/core';
import { NEW_SONG_FORM_STEPS_COUNT } from '~/features/dashboard';
import { Step_1 } from '~/features/dashboard/components/add-song/components/step-1';
import { Step_2 } from '~/features/dashboard/components/add-song/components/step-2';
import { Step_3 } from '~/features/dashboard/components/add-song/components/step-3';
import { Step_4 } from '~/features/dashboard/components/add-song/components/step-4';
import { Step_5 } from '~/features/dashboard/components/add-song/components/step-5';
import { Step_6 } from '~/features/dashboard/components/add-song/components/step-6';
import { Step_7 } from '~/features/dashboard/components/add-song/components/step-7';
import {getMusicsThunk, getSongEditDetailThunk, getTagListings} from './../../store/actions.thunks';
import Check from '@material-ui/icons/Check';
import { editNewSongForm } from '~/features/dashboard/store/actions';
import { useLocation } from 'react-router-dom';
import { useThunkDispatch } from '~/utils/hooks/useThunkDispatch';
import { Loader } from '~/common/loader';
import { makeStyles } from '@material-ui/core/styles';
import { StepIconProps } from '@material-ui/core/StepIcon';
import { Typography, Drawer, Divider, Button } from '@material-ui/core';
import { DownloadButton } from '~/common/download-button';
import { TODODRAWER } from '~/features/dashboard/components/todo-drawer';
import { push } from 'connected-react-router';
import clsx from 'clsx';
import { ExitToApp } from '@material-ui/icons';
import { axiosInstance } from '~/api/config/axios.config';
import { LabelStepSong } from '~/models/music/new-song/helpers';
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
interface AddSongProps {}

interface noteData_props {
    id: number;
    gSongRef: string;
    notes: string;
    completed: number;
    isDelete: number;
}

var lastSegment: any;
export const AddSong: React.FC<AddSongProps> = () => {
    const newSongState = useSelector(selectNewSong);
    const step = useSelector(selectNewSongStep);
    const dispatch = useThunkDispatch();
    const [isLoading, setIsLoading] = React.useState(true);
    const match = useRouteMatch<{ creatorId: string }>();
    const location = useLocation<{ gotoStep: any }>();

    const [notesData, setNotesData] = useState<noteData_props[]>([]);
    const [toDosData, setToDosData] = useState<noteData_props[]>([]);
    const [noteDrawer, setNoteDrawer] = useState(false);

    const {
        state: { gotoStep },
    } = location;
    const {
        params: { creatorId },
    } = match;

    useEffect(() => {
        if (newSongState && newSongState.gProjectId !== Number(creatorId)) {
            dispatch(resetNewSongForm());
        }
        dispatch(getMusicsThunk({ creatorId: Number(creatorId) }));
        dispatch(getTagListings());
    }, [creatorId, dispatch, newSongState]);

    useEffect(() => {
        var parts = window.location.href.split('/');
        lastSegment = parts.pop() || parts.pop(); // handle potential trailing slash
        getSongDetail(lastSegment);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    const getSongDetail = async (lastSegment: any) => {
        if (lastSegment !== 'add-song') {
            dispatch(getSongEditDetailThunk({ assetCode: lastSegment, gotoStep: gotoStep })).finally(() => setIsLoading(false));
        } else {
            dispatch(resetNewSongForm());
            setIsLoading(false);
        }
    };
    const prevStep = useCallback(() => {
        dispatch(newSongFormPrevStep());
    }, [dispatch]);
    // const gotoStepSong = async (step: any) => {
    //     setIsLoading(true);
    //     dispatch(getSongEditDetailThunk({ assetCode: lastSegment, gotoStep: step })).finally(() => setIsLoading(false));
    // };

    const useQontoStepIconStyles = makeStyles({
        root: {
            color: '#eaeaf0',
            display: 'flex',
            height: 22,
            alignItems: 'center',
        },
        active: {
            color: '#6cb9b7',
        },
        circle: {
            width: 40,
            height: 40,
            borderRadius: '50%',
            backgroundColor: 'currentColor',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        completed: {
            color: '#fff',
            backgroundColor: '#6cb9b7',
            zIndex: 1,
            fontSize: 18,
            width: 40,
            height: 40,
            padding: 8,
            borderRadius: '100%',
        },
    });

    function QontoStepIcon(props: StepIconProps) {
        const classes = useQontoStepIconStyles();
        const { active, completed, icon } = props;

        return (
            <div
                className={clsx(classes.root, {
                    [classes.active]: active,
                })}
            >
                {completed ? <Check className={classes.completed} /> :
                    <div className={classes.circle}>
                        <span className={css.spanCircle}>{icon}</span>
                    </div>
                }
            </div>
        );
    }

    const isSongEditing = useSelector(selectIsSongEditing);

    React.useEffect(() => {
        if (newSongState) {
            axiosInstance.get(`/Catalogue/projectcreator/songtodolist?gSongRef=${newSongState.gSongRef}`).then(res => {
                setToDosData(res.data);
            });

            axiosInstance.get(`/Catalogue/projectcreator/songnoteslist?gsongRef=${newSongState.gSongRef}`).then(res => {
                setNotesData(res.data);
            });
        }
    }, [newSongState]);
    const gotoBack = () => {
        dispatch(push(`/creators-list/${creatorId}/dashboard/songs/table/${newSongState?.gSongRef}/details`));
    };

    const goToRecordings = () => {
        dispatch(newSongFormGoToStep({ step: 3 }));
    };

    return isLoading ? (
        <Loader />
    ) : (
        <div className={css.module}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
                <Box width={1}>
                    <div className={css.infobtnouter}>
                        {isSongEditing ? (
                            <Button
                                className={css.backbtncustom}
                                variant="contained"
                                color="secondary"
                                disableElevation
                                startIcon={<ExitToApp />}
                                onClick={gotoBack}
                                title="Go to Song"
                            />
                        ) : (
                            ``
                        )}
                        <Stepper className={css.stepper} alternativeLabel activeStep={step - 1}>
                            {Array.from({ length: NEW_SONG_FORM_STEPS_COUNT }, () => '').map((_, index) =>
                                isSongEditing ? (
                                    <Step key={index} onClick={() => dispatch(editNewSongForm({ step: index }))} style={{ cursor: 'pointer' }}>
                                        <StepLabel className={css.stepspan} StepIconComponent={QontoStepIcon}>
                                            {LabelStepSong[index]}
                                        </StepLabel>
                                    </Step>
                                ) : (
                                    <Step key={index}>
                                        <StepLabel className={css.stepspan} StepIconComponent={QontoStepIcon}>
                                            {LabelStepSong[index]}
                                        </StepLabel>
                                    </Step>
                                )
                            )}
                        </Stepper>
                        {isSongEditing && newSongState && (
                            <div className={css.notesSection}>
                                <DownloadButton buttonFor="save" onClick={() => setNoteDrawer(true)} className={css.downloadButton1} />
                            </div>
                        )}
                    </div>
                    {step === 1 && <Step_1 />}
                    {step === 2 && <Step_2 prevStep={prevStep} />}
                    {step === 3 && <Step_4 prevStep={prevStep} />}
                    {step === 4 && <Step_6 prevStep={prevStep} />}
                    {step === 5 && <Step_3 prevStep={prevStep} goToRecordings={goToRecordings} />}
                    {step === 6 && <Step_5 prevStep={prevStep} />}
                    {step === 7 && <Step_7 prevStep={prevStep} />}
                </Box>
            </MuiPickersUtilsProvider>

            <Drawer variant="persistent" anchor={'right'} open={noteDrawer} onClose={() => setNoteDrawer(false)} className={css.drawerStyle}>
                <div style={{ borderBottom: '1px solid #ccc', padding: '10px 0px 10px 24px', verticalAlign: 'center'}}>
                    <div
                        className={css.closeBtn}
                        onClick={() => {
                            setNoteDrawer(false);
                        }}
                    >
                        <ArrowBackIcon style={{ verticalAlign: 'center', lineHeight: '10px', cursor: 'pointer' }} />
                        <Typography variant={'h6'} className={css.drawertitle} style={{ lineHeight: '25px', cursor: 'pointer', marginLeft: '0.5rem' }}>
                            Close
                        </Typography>
                    </div>
                </div>
                <Divider />
                <TODODRAWER
                    songId={newSongState?.gSongRef}
                    notesData={notesData}
                    toDoData={toDosData}
                    setNotesData={setNotesData}
                    setToDosData={setToDosData}
                />
            </Drawer>
        </div>
    );
};
